/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export { AnimationGroupPlayer as ɵAnimationGroupPlayer } from './players/animation_group_player';
export const /** @type {?} */ ɵPRE_STYLE = '!';
//# sourceMappingURL=private_export.js.map